import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconClipboardSvg } from "./IconClipboardSvg.mjs";
const IconClipboard = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconClipboardSvg, ...iconProps });
};
export {
  IconClipboard
};
